// eslint-disable-next-line no-restricted-imports
import { MutationInput_LegalClientController_UpdateById_Input_Category as CategoryApi } from 'api/generated/graphql';
import { LegalClientCategoryType } from 'api/types/entity';
import { Maybe } from 'types/maybe';

const category: Record<LegalClientCategoryType, CategoryApi> = {
  [LegalClientCategoryType.BrokerDealers]: CategoryApi.BrokerDealers,
  [LegalClientCategoryType.InsuranceOrganizations]:
    CategoryApi.InsuranceOrganizations,
  [LegalClientCategoryType.InvestmentFund]: CategoryApi.InvestmentFund,
  [LegalClientCategoryType.InvestmentFunds]: CategoryApi.InvestmentFunds,
  [LegalClientCategoryType.LegalEntityNonResident]:
    CategoryApi.LegalEntityNonResident,
  [LegalClientCategoryType.LegalEntityResident]:
    CategoryApi.LegalEntityResident,
  [LegalClientCategoryType.NominalHoldersResident]:
    CategoryApi.NominalHoldersResident,
  [LegalClientCategoryType.OtherFinancialMarketLicensees]:
    CategoryApi.OtherFinancialMarketLicensees,
  [LegalClientCategoryType.OtherLegalEntitiesNonResident]:
    CategoryApi.OtherLegalEntitiesNonResident,
  [LegalClientCategoryType.OtherLegalEntitiesResident]:
    CategoryApi.OtherLegalEntitiesResident,
  [LegalClientCategoryType.PensionFundOwnAssets]:
    CategoryApi.PensionFundOwnAssets,
  [LegalClientCategoryType.PensionFundPensionAssets]:
    CategoryApi.PensionFundPensionAssets,
  [LegalClientCategoryType.SecondTierBank]: CategoryApi.SecondTierBank,
  [LegalClientCategoryType.AIFCParticipant]: CategoryApi.AifcParticipant,
  [LegalClientCategoryType.KazakhstanResidenceExceptAIFCParticipants]:
    CategoryApi.KazakhstanResidenceExceptAifcParticipants,
  [LegalClientCategoryType.CentralAsiaResidenceExceptKazakhstan]:
    CategoryApi.CentralAsiaResidenceExceptKazakhstan,
  [LegalClientCategoryType.AsiaResidenceExceptCentralAsia]:
    CategoryApi.AsiaResidenceExceptCentralAsia,
  [LegalClientCategoryType.EuropeResidence]: CategoryApi.EuropeResidence,
  [LegalClientCategoryType.AmericasResidence]: CategoryApi.AmericasResidence,
  [LegalClientCategoryType.AustraliaResidence]: CategoryApi.AustraliaResidence,
  [LegalClientCategoryType.AfricaResidence]: CategoryApi.AfricaResidence,
  [LegalClientCategoryType.RussianFederationResidence]:
    CategoryApi.RussianFederationResidence,
};

export const parseCategoryTypeParam = (
  data: Maybe<LegalClientCategoryType>
): CategoryApi | null => (data ? category[data] : null);
